(function($, Drupal) {
  'use strict';
  Drupal.behaviors.clientList = {
    attach: function(context, settings) {
      let $marqueeInner,
          $translateY,
          $speed,
          $isPaused,
          $animationFrameId,
          $originalContentHeight,
          $updatedContentHeight,
          $pauseButton;

      if ($('.layout-builder-form', context).length) {
        return; // Skip if in layout builder context
      }

      if ($('.client-list-scroll', context).hasClass('client-list-logos-initialized')) {
        return;
      }
      $('.client-list-scroll', context).addClass('client-list-logos-initialized');

      // 1. Find the element
      const marqueeElement = $('.client-list-logos', context)[0];

      // 2. ONLY proceed if the element exists on this page
      if (!marqueeElement) {
        return;
      }

      $marqueeInner = marqueeElement;

      $translateY = 0;
      $speed = 0.75; // px per frame
      $isPaused = false;

      // Height of one full marquee-content block
      $originalContentHeight = $marqueeInner.scrollHeight;

      function animate() {
        $animationFrameId = requestAnimationFrame(animate);
        $translateY -= $speed;

        if ($isPaused) {
          cancelAnimationFrame($animationFrameId);
          $animationFrameId = null;
          return;
        }
        // Reset translateY when scrolled past one block height for seamless loop
        if (-$translateY >= ($updatedContentHeight - $originalContentHeight)) {
          $translateY = 0;
        }

        $marqueeInner.style.transform = `translate3d(0, ${$translateY}px, 0)`;
      }

      function duplicateLogos() {
        // set all variables
        let $container,
            $originalLogos,
            $itemsPerRow,
            $rowsPerBlock,
            $windowSize,
            $originalHTML,
            $padCount,
            $paddedOriginal,
            $originalPattern,
            $sequence,
            $maxIterations;

        $container = $('.logos');

        $originalLogos = $container.children('.logo');

        $itemsPerRow = 3;
        $rowsPerBlock = 3;
        $windowSize = 9;

        if (window.innerWidth < 768) {
          $itemsPerRow = 2;
          $rowsPerBlock = 2;
          $windowSize = 4;
        }
        else {
          $itemsPerRow = 3;
          $rowsPerBlock = 3;
          $windowSize = 9;
        }

        $originalHTML = $originalLogos.map(function() {
          return $(this).prop('outerHTML');
        }).get();

        // These count controls how many logos are attached to finish the 3x3 pattern
        // If the original logos are not enough to fill the pattern, we will pad with duplicates
        $padCount = ($originalLogos.length % $itemsPerRow);
        if (window.innerWidth > 768) {
          if ($padCount === 1) {
            $padCount = 2;
          }
          else if ($padCount === 2) {
            $padCount = 1;
          }
        }
        else {
          $padCount = 1;
        }

        // Pad if needed to make at least 3 full rows
        $paddedOriginal = [...$originalHTML];
        $originalPattern = $paddedOriginal.slice(0, $windowSize).join('');
        $sequence = [...$originalHTML];
        $maxIterations = 20; // Limit iterations to prevent infinite loops

        for (let i = 1; i <= $maxIterations; i++) {
          // how many full rows in current sequence?
          const rowCount = Math.floor($sequence.length / $itemsPerRow);
          for (let r = 1; r <= rowCount - $rowsPerBlock; r++) {
            const start = r * $itemsPerRow;
            const block = $sequence.slice(start, start + $windowSize).join('');
            if (block === $originalPattern) {
              if ($padCount > 0) {
                $sequence = $sequence.concat($originalHTML.slice(0, $padCount));
              }
              $container.html($sequence.join(''));
              return;
            }
          }

          // append another full set of the original logos
          $sequence = $sequence.concat($originalHTML);
        }
      }

      $pauseButton = $('#pause-logos', context);
      $pauseButton.once('motion-toggle-initialized').on('click', function() {
        $isPaused = !$isPaused;
        $(this).addClass($isPaused ? 'paused' : 'playing');

        if (!$isPaused) {
          animate();
        }
        else {
          cancelAnimationFrame($animationFrameId);
          $animationFrameId = null;
        }
      });

      duplicateLogos();

      // Grab the updated content height after duplication
      // This is necessary to ensure the animation works correctly with the new content
      // Defer height calculation to allow DOM update to complete
      if ($marqueeInner) {
        $updatedContentHeight = $marqueeInner.scrollHeight;
        animate();
      }
    }
  };
})(jQuery, Drupal);
